import React from "react";
import styles from "./DashboardCard.module.scss";
import { Link } from "react-router-dom";

const DashboardCard = ({ title, subtitle, link, img }) => {
  return (
    <div className={styles.card}>
      <img src={img} alt={title} className={styles.cardImage} />

      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle}>{title}</h3>
        <p className={styles.cardSubtitle}>{subtitle}</p>

        <Link to={link} className={styles.cardButton}>
          Aller à →
        </Link>
      </div>
    </div>
  );
};

export default DashboardCard;
